import { useMutation } from '@tanstack/react-query';

import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { updateEnvelope } from '../../requests/updateEnvelope';

type UpdateEnvelopeVariables = {
  envelopeId: string;
  data: Record<string, any>;
};

export const useUpdateEnvelope = () => {
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    unknown,
    Error,
    UpdateEnvelopeVariables
  >({
    mutationFn: ({ envelopeId, data }) =>
      updateEnvelope(constructPatch, envelopeId, data),
    onError: () => handleError('Failed to save envelope.'),
  });

  return { updateEnvelope: mutateAsync, ...rest };
};
